module.exports = __webpack_public_path__ + "img/icon-illustration-coupon-item-red.755557b8.svg";